import React from "react";
import ViewDeletedCheckbox from "./ViewDeletedCheckbox";
import SearchConfiguration from "./SearchConfiguration";
import AddConfigurationButton from "./AddConfigurationButton";

interface Props {
  configs: any;
  setConfigs: React.Dispatch<React.SetStateAction<any>>;
  AddConfigurationsButton: any;
}

const ConfigurationControls: React.FC<Props> = ({ configs, setConfigs, AddConfigurationsButton }) => {
  return (
    <div className="customer-toolbar flex items-center justify-end gap-4 p-2">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-6 w-full sm:w-[95vw] lg:w-[88vw] min-h-[60px] py-[15px] rounded-lg">
        {/* <div className="flex items-center gap-2"> */}
          <ViewDeletedCheckbox
            checked={configs.showDeleted}
            onChange={() => setConfigs((prev: typeof configs) => ({ ...prev, showDeleted: !prev.showDeleted }))}
          />

          <SearchConfiguration
            value={configs.searchQuery}
            onChange={(e) => setConfigs((prev: typeof configs) => ({ ...prev, searchQuery: e.target.value }))}
          />

          <AddConfigurationButton
            Buttondata={AddConfigurationsButton}
            onClick={() => setConfigs((prev: typeof configs) => ({ ...prev, openAdd: true }))}
          />

        {/* </div> */}
      </div>
    </div>
  );
};

export default ConfigurationControls;
